import React from 'react';
import { IconProps } from '../../types/types';

const ColumnIdentifierIcon: React.FC<IconProps> = ({ size = '18', color = '#1E1E1E'}) => {
    return (
<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.875 14.925V3.075C7.875 1.95 7.395 1.5 6.2025 1.5H3.1725C1.98 1.5 1.5 1.95 1.5 3.075V14.925C1.5 16.05 1.98 16.5 3.1725 16.5H6.2025C7.395 16.5 7.875 16.05 7.875 14.925Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.5 8.175V3.075C16.5 1.95 16.02 1.5 14.8275 1.5H11.7975C10.605 1.5 10.125 1.95 10.125 3.075V8.175C10.125 9.3 10.605 9.75 11.7975 9.75H14.8275C16.02 9.75 16.5 9.3 16.5 8.175Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.5 14.925V13.575C16.5 12.45 16.02 12 14.8275 12H11.7975C10.605 12 10.125 12.45 10.125 13.575V14.925C10.125 16.05 10.605 16.5 11.7975 16.5H14.8275C16.02 16.5 16.5 16.05 16.5 14.925Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>



    );
};

export default ColumnIdentifierIcon;
